import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export type ClientProfileSettingsResponse = {
  hiddenFields: string[]
  syncedFields: string[]
}

type GetClientProfileSettingsRequest = {
  buildingId: number | undefined
}

export const getClientProfileSettingsQueryKey = (data: GetClientProfileSettingsRequest) => [
  'useGetClientProfileSettings',
  data,
]

const getClientProfileSettings = async (data: GetClientProfileSettingsRequest) => {
  const response = await authAPI.get<ClientProfileSettingsResponse>('/client/profile-settings', {
    params: { buildingId: data.buildingId },
  })
  return response.data
}

export const useGetClientProfileSettings = (data: GetClientProfileSettingsRequest) =>
  useQuery({
    enabled: !!data.buildingId,
    queryFn: () => getClientProfileSettings(data),
    queryKey: getClientProfileSettingsQueryKey(data),
  })
